document.addEventListener('click', function (event) {
  const shareBtn = event.target.closest('.js-share');
  if (!shareBtn) return;

  const title = shareBtn.dataset.title || '';
  const url = shareBtn.dataset.url || '';

  if (!url) return;

  if (navigator.share) {
    navigator.share({ title: title, url: url });
    return;
  }

  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(url).then(() => {
      alert('Link copiado para a área de transferência');
    });
    return;
  }

  window.prompt('Copie o link abaixo:', url);
});

document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('downloadModal');
  const form = document.getElementById('downloadLeadForm');

  if (!modal || !form) return;

  const modalTitle = document.getElementById('downloadModalTitle');
  const inputId = document.getElementById('downloadLeadId');
  const inputUrl = document.getElementById('downloadLeadUrl');
  const inputTitle = document.getElementById('downloadLeadTitle');
  const inputCategory = document.getElementById('downloadLeadCategory');
  const inputCategorySlug = document.getElementById('downloadLeadCategorySlug');
  const inputOriginCategory = document.getElementById('downloadLeadOriginCategory');
  const estadoSelect = document.getElementById('downloadLeadEstado');
  const cidadeSelect = document.getElementById('downloadLeadCidade');

  let statesData = [];

  function setBodyLock(lock) {
    if (lock) {
      document.body.classList.add('is-download-modal-open');
      return;
    }
    document.body.classList.remove('is-download-modal-open');
  }

  function openModal(downloadData) {
    const safeData = downloadData || {};

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');

    if (modalTitle) modalTitle.textContent = safeData.title || 'Título do material';
    if (inputId) inputId.value = safeData.id || '';
    if (inputTitle) inputTitle.value = safeData.title || '';
    if (inputCategory) inputCategory.value = safeData.category || '';
    if (inputCategorySlug) inputCategorySlug.value = safeData.categorySlug || '';
    if (inputOriginCategory) inputOriginCategory.value = safeData.originCategory || safeData.categorySlug || '';
    if (inputUrl) inputUrl.value = safeData.url || '';

    setBodyLock(true);
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    setBodyLock(false);
  }

  function triggerDownload(fileUrl) {
    if (!fileUrl) return;

    const link = document.createElement('a');
    link.href = fileUrl;
    link.setAttribute('download', '');
    link.rel = 'noopener';
    link.style.display = 'none';

    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  function renderStates() {
    if (!estadoSelect) return;

    let options = "<option value=''>Estado</option>";
    statesData.forEach((estado) => {
      options += "<option value='" + estado.sigla + "'>" + estado.nome + '</option>';
    });

    estadoSelect.innerHTML = options;
  }

  function renderCities(stateCode) {
    if (!cidadeSelect) return;

    if (!stateCode) {
      cidadeSelect.innerHTML = "<option value=''>Cidade</option>";
      return;
    }

    const selectedState = statesData.find((estado) => estado.sigla === stateCode);
    if (!selectedState) {
      cidadeSelect.innerHTML = "<option value=''>Cidade</option>";
      return;
    }

    let options = "<option value=''>Cidade</option>";
    selectedState.cidades.forEach((cidade) => {
      options += "<option value='" + cidade + "'>" + cidade + '</option>';
    });

    cidadeSelect.innerHTML = options;
  }

  async function loadStatesAndCities() {
    if (!estadoSelect || !cidadeSelect) return;

    try {
      const response = await fetch('https://gist.githubusercontent.com/letanure/3012978/raw/36fc21d9e2fc45c078e0e0e07cce3c81965db8f9/estados-cidades.json');
      if (!response.ok) throw new Error('Falha ao carregar lista de estados');

      const data = await response.json();
      statesData = Array.isArray(data.estados) ? data.estados : [];

      renderStates();
      renderCities('');
    } catch (error) {
      estadoSelect.innerHTML = "<option value=''>Estado</option>";
      cidadeSelect.innerHTML = "<option value=''>Cidade</option>";
    }
  }

  async function submitLeadData() {
    if (
      typeof window.downloadLeadAjax === 'undefined' ||
      !window.downloadLeadAjax ||
      !window.downloadLeadAjax.ajaxUrl
    ) {
      return {
        success: false,
        message: 'Integração de leads indisponível.'
      };
    }

    try {
      const payload = new FormData(form);
      payload.append('action', window.downloadLeadAjax.action || 'negocios_download_lead');
      payload.append('nonce', window.downloadLeadAjax.nonce || '');

      const response = await fetch(window.downloadLeadAjax.ajaxUrl, {
        method: 'POST',
        body: payload,
        credentials: 'same-origin'
      });

      if (!response.ok) {
        return {
          success: false,
          message: window.downloadLeadAjax.errorMessage || 'Falha ao salvar seu lead.'
        };
      }

      const result = await response.json();

      if (result && result.success) {
        return {
          success: true,
          message: '',
          traceId: result && result.data ? result.data.trace_id : ''
        };
      }

      return {
        success: false,
        traceId: (result && result.data && result.data.trace_id) ? result.data.trace_id : '',
        message: (result && result.data && result.data.message)
          ? result.data.message
          : (window.downloadLeadAjax.errorMessage || 'Falha ao salvar seu lead.')
      };
    } catch (error) {
      return {
        success: false,
        traceId: '',
        message: window.downloadLeadAjax.errorMessage || 'Falha ao salvar seu lead.'
      };
    }
  }

  document.addEventListener('click', function (event) {
    const downloadBtn = event.target.closest('.js-download-gated');
    if (!downloadBtn) return;

    event.preventDefault();
    openModal({
      id: downloadBtn.dataset.downloadId || '',
      title: downloadBtn.dataset.downloadTitle || '',
      url: downloadBtn.dataset.downloadUrl || downloadBtn.getAttribute('href') || '',
      category: downloadBtn.dataset.downloadCategory || '',
      categorySlug: downloadBtn.dataset.downloadCategorySlug || '',
      originCategory: downloadBtn.dataset.downloadCategorySlug || ''
    });
  });

  modal.addEventListener('click', function (event) {
    if (!event.target.closest('.js-download-modal-close')) return;
    closeModal();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || !modal.classList.contains('is-open')) return;
    closeModal();
  });

  if (estadoSelect) {
    estadoSelect.addEventListener('change', function () {
      renderCities(estadoSelect.value);
    });
  }

  form.addEventListener('submit', async function (event) {
    event.preventDefault();

    if (!form.reportValidity()) return;

    const submitButton = form.querySelector('button[type="submit"]');
    if (submitButton) submitButton.disabled = true;

    const leadResponse = await submitLeadData();

    if (submitButton) submitButton.disabled = false;

    if (!leadResponse.success) {
      const traceSuffix = leadResponse.traceId ? (' Código: ' + leadResponse.traceId) : '';
      alert((leadResponse.message || 'Não foi possível registrar seu lead.') + traceSuffix);
      return;
    }

    if (leadResponse.traceId) {
      console.info('Lead RD Station enviado com sucesso. Código:', leadResponse.traceId);
    }

    const fileUrl = inputUrl ? inputUrl.value : '';
    triggerDownload(fileUrl);

    form.reset();
    renderCities('');
    closeModal();
  });

  loadStatesAndCities();
});
